export var buttonContentStyles = {
    root: function () {
        return {
            fontWeight: "var(--button__content--font-weight, 400)",
        };
    },
};
//# sourceMappingURL=buttonContent-styles.js.map